import { ProjectHubEntryFilterType } from '@/features/projects/projects-hub/components/project-hub-filter/project-hub-entry-filter-type';
import { ProjectRole } from '@/features/projects/shared/types/project-role';
import { ProjectStatus } from '@/features/projects/shared/types/project-status';
import { supabase } from '@/lib/supabase';
import { ProjectWithContractors } from '@/shared/types/api';
import { NotificationReadStatus } from '@/shared/types/filter/notification-filter-type';
import { formatDate } from '@/shared/utils/format';

export interface ProjectFilters {
  statuses: ProjectStatus[] | undefined;
  partnerIds: string[] | undefined;
  roles: ProjectRole[] | undefined;
  notificationStatuses: NotificationReadStatus[] | undefined;
  lastEntry: ProjectHubEntryFilterType[] | undefined;
  searchQuery: string | undefined;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
}

export const getOrgProjects = async ({
  orgId,
  filters,
  limit,
}: {
  orgId: number;
  filters?: ProjectFilters;
  limit?: number;
}): Promise<ProjectWithContractors[]> => {
  let query = supabase.rpc('get_filtered_org_projects', {
    p_org_id: orgId,
    p_statuses: filters?.statuses,
    p_partners_ids: filters?.partnerIds,
    p_roles: filters?.roles,
    p_notification_types: filters?.notificationStatuses,
    p_last_entry_types: filters?.lastEntry,
    p_search_query: filters?.searchQuery,
    p_date_from: filters?.dateFrom
      ? formatDate({
          date: filters.dateFrom,
          formatType: 'iso',
        })
      : undefined,
    p_date_to: filters?.dateTo
      ? formatDate({
          date: filters.dateTo,
          formatType: 'iso',
        })
      : undefined,
  });

  // Only apply limit if it's defined
  if (limit !== undefined) {
    query = query.limit(limit);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data as ProjectWithContractors[]).map((project) => ({
    ...project,
    // remove duplicates
    contractors: project.contractors.filter(
      (contractor, index, self) =>
        index === self.findIndex((t) => t.id === contractor.id),
    ),
  }));
};
